import ContentInterestCardCommon from './containers/contentInterestCardCommon'

export {default as ContentInterestCardCommonLayout} from './components/contentInterestCardCommonLayout'

export default ContentInterestCardCommon
